import { Spinner } from "@projectobelisk/uikit/components/feedback/spinner";

export function FullPageSpinner() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner className="size-8" />
    </div>
  );
}
